export const LIKE_MARK = 1;
export const DISLIKE_MARK = 2;
export const NEUTRAL_MARK = null;
